import React from 'react';
import { Box, Grid } from '@mui/material';
import { PDF_HEIGHT } from 'hooks/usePdfExport/usePdfExport';

export interface PdfLayoutProps {
  header: React.ReactNode;
  microgridSetup: React.ReactNode;
  proposedSolution: React.ReactNode;
  businessCaseComparison: React.ReactNode;
  energySources: React.ReactNode;
  powerRequirement: React.ReactNode;
  calculationDetails: React.ReactNode;
  disclaimer: React.ReactNode;
}

export function PdfLayout({
  header,
  microgridSetup,
  proposedSolution,
  businessCaseComparison,
  energySources,
  powerRequirement,
  calculationDetails,
  disclaimer,
}: PdfLayoutProps) {
  const CONTENT_WIDTH = '73%';
  const GAP_HEIGHT = 2.5;
  const sections = [energySources, powerRequirement, calculationDetails, disclaimer];

  const Page1 = () => (
    <Box sx={{ height: PDF_HEIGHT, background: (theme) => theme.palette.grey[100] }}>
      <Grid container height="360px">
        <Grid item xs={6} height="100%">
          {header}
        </Grid>
        <Grid item xs={6} height="100%">
          {microgridSetup}
        </Grid>
      </Grid>

      <Box sx={{ mb: GAP_HEIGHT }}>{proposedSolution}</Box>

      <Box sx={{ display: 'flex', justifyContent: 'center' }}>
        <Box sx={{ width: CONTENT_WIDTH }}>{businessCaseComparison}</Box>
      </Box>
    </Box>
  );

  const Page2 = () => (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: GAP_HEIGHT, pt: GAP_HEIGHT }}>
      {sections.map((section, index) => (
        <Box key={index} sx={{ display: 'flex', justifyContent: 'center' }}>
          <Box sx={{ width: CONTENT_WIDTH }}>{section}</Box>
        </Box>
      ))}
    </Box>
  );

  return (
    <>
      <Page1 />
      <Page2 />
    </>
  );
}
